module.exports = __webpack_public_path__ + "img/8V.ed07875c.png";